import {ApiRequest} from './request'
import Overlay, {amountValidate} from './overlay'

/**
 * Put the overlay in loading mode
 */

const loadingMode = function()
{
    $('.overlay-loader').toggleClass('show')
}

/**
 * Handle the Go to Paypal click
 *
 * @param event
 */

const goToPaypal = async function(event)
{

    // Prevent default action
    event.preventDefault()

    // Get the trigger
    const $trigger = $(this)

    // Blur the button
    $trigger.blur()

    // Show loader
    loadingMode()

    try {

        // Get the payment link
        let response = await ApiRequest($trigger.data('target'), null, 'GET')

        // Redirect the user to PayPal
        window.location = response.url

    } catch(err) {

        // Display the message
        alert('Payment Error! Please contact an administrator.')

        // Hide loader
        loadingMode()

    }

}

/**
 * Handle the Other Method change
 *
 * @return void
 */

const onOtherMethodChange = function()
{

    // Get the trigger
    const $trigger = $(this)

    // Get the method
    const $method = $trigger.parents('.method')

    // Get the methods
    const $methods = $method.parents('.methods')

    // Get the button
    const $button = $trigger.parents('form').find('.btn-primary')

    if($method.hasClass('with-checkbox')) {
        $trigger.is(':checked') ? $method.addClass('checked') : $method.removeClass('checked')
    }

    // Get the checked checkboxes
    const checked = $methods.find(':checkbox:checked')

    // Disable or enable the button
    $button.attr('disabled', checked.length === 0)

}

/**
 * Go back to the payment methods
 *
 * @param event
 */

const goBackToMethods = function(event)
{

    event.preventDefault()

    // Get the section
    const $section = $(this).parents('.section')

    // Hide the section
    $section.removeClass('active')

    // Show the previous one
    $section.parents('.overlay-com').find('.section.methods').addClass('active')

}

/**
 * Go to Other Methods
 *
 * @param event
 */

const goToOtherMethods = function(event)
{

    event.preventDefault()

    // Get the trigger
    const $trigger = $(this)

    // Get the context
    const $context = $trigger.parents('.overlay-com')

    // Hide the active sections
    $context.find('.section.active').removeClass('active')

    // Show the new section
    $('.section#' + $trigger.data('target')).addClass('active')

    // Amount validation
    var form = document.querySelector('.other-methods-funds-form');
    if(form){
        if (form.getAttribute('submit_listener') !== 'true') {
            form.addEventListener("submit", function (e) {
                e.target.setAttribute('submit_listener', 'true');
                if (!amountValidate()) {
                    e.preventDefault();
                }
            });
        }
    }
}

const goToFundsMethods = function(event)
{

    event.preventDefault()

    // Get the trigger
    const $trigger = $(this)

    // Get the context
    const $context = $trigger.parents('.overlay-com')

    // Hide the active sections
    $context.find('.section.active').removeClass('active')

    // Show the new section
    $('.section#' + $trigger.data('target')).addClass('active')

    $('input[name="funds-method"]').unbind('change').on('change', function () {
        $(this).parents('form.form-panel').find('button[type="submit"]').prop("disabled", false);
    })
}

const goToFundsTrafficMethods = function(event)
{
    event.preventDefault()
    const overlay = Overlay()
    overlay.showLoader()

    // Get the trigger
    const $trigger = $(this)

    // Get the context
    const url = $trigger.attr('href')

    window.location = url

    setTimeout(() => {
        overlay.hideLoader()
    },5000)
}

const showMembershipType = function(event)
{
    const $trigger = $(this)

    const type = $trigger.data('type')
    const wrapper = $(`#${type}-membership-wrap`)
    const modal = $trigger.parents('.pay-now.show')

    if(wrapper && wrapper.length === 1){
        $('#membership-types-wrap').hide();
        $('.membership-types-button-wrap').show();
        wrapper.show();

        modal.find('.heading .title').html(`Select a ${type} payment method`)
    }
}

const backToMembershipTypes = function()
{
    const $trigger = $(this)
    const modal = $trigger.parents('.pay-now.show')

    $('.methods').hide();
    $('.membership-types-button-wrap').hide();
    $('#membership-types-wrap').show();

    modal.find('.heading .title').text('Select a payment method')
}

const showPayPopUp = function () {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const pay_now = urlParams.get('pay_now')

    if(pay_now == 1){
        setTimeout(() => {
            const el = $('a[data-overlay="pay-now"]')
            if(el.length > 0 && el.attr('data-clicked') != 1){
                el[0].click();
                el.attr('data-clicked', 1)
                history.pushState("", document.title, window.location.pathname);
            }
        },0);
    }
}

const setup = function()
{

    const $body = $('body')

    // Handle Go To Paypal click
    $body.on('click', '.pay-now .method.go-to-paypal', goToPaypal)

    // Handle Other Method change
    $body.on('change', '.pay-now #other-methods :checkbox', onOtherMethodChange)

    // Go back to payment methods
    $body.on('click', '.pay-now .section .go-back', goBackToMethods)

    // Go to Other Methods
    $body.on('click', '.pay-now .method.other', goToOtherMethods)

    // Go to Funds Methods
    $body.on('click', '.pay-now .method.funds', goToFundsMethods)

    // Go to Funds Methods
    $body.on('click', '.pay-now .method.funds-traffic', goToFundsTrafficMethods)

    // Choose Membership Type
    $body.on('click', '.pay-now .method.membership-type', showMembershipType)

    // Go to Funds Methods
    $body.on('click', '.pay-now .section .back-to-types', backToMembershipTypes)

    showPayPopUp()
}

export default function payNow(app)
{
    $(setup)
}
